/*
 * Copyright (c) 2024-2025. Bolmate B.V.
 */
import './style/warningMessage.scss';

import React from 'react';
import WarnIcon from "../../icon/warnIcon";
import classNames from 'classnames';

interface Props {
    onClose?: React.MouseEventHandler;
    className?: string;
    closeText?: string;
}

export default function WarningMessage(props: React.PropsWithChildren<Props>) {
    const {className, children, onClose} = props;
    const closeText = props.closeText ?? 'Oké, ik begrijp het';
    const gridColumns = onClose === undefined ? 'fit-content(100%) 1fr' : 'fit-content(100%) 1fr fit-content(100%)';
    return (
        <div className={classNames('warning-message-container', className)} style={{gridTemplateColumns: gridColumns}}>
            <WarnIcon/>
            {children}
            {onClose !== undefined && <label className='close-label' onClick={onClose}>{closeText}</label>}
        </div>
    )
}